import { getEnvState } from "JavaScripts/state"

export const VAPID_PUBLIC_KEY = new Uint8Array(getEnvState().VAPID_PUBLIC_KEY)
